import * as React from 'react';

import { Modal } from '@lightspeed/flame/Modal';
import ModalBody from './ModalBody';
import ModalFooter from './ModalFooter';
import ModalHeader from './ModalHeader';

interface Props {
  isOpen: boolean;
  onModalClose?: () => void;
  onModalSave?: () => void;
  setIsOpen: (newIsOpen: boolean) => void;
}

const EditShopsModal: React.FC<Props> = ({ isOpen, onModalClose, onModalSave, setIsOpen }) => {
  const handleCloseModal = () => {
    onModalClose?.();
    setIsOpen(false);
  };

  return (
    <Modal
      css={{ width: '600px', maxHeight: '900px' }}
      data-testid="edit-shops-modal"
      isOpen={isOpen}
      onRequestClose={handleCloseModal}
    >
      <ModalHeader />
      <ModalBody />
      {/* @ts-expect-error ts-migrate(2322) FIXME: Type '(() => void) | undefined' is not assignable ... Remove this comment to see the full error message */}
      <ModalFooter onCancelClick={handleCloseModal} onSaveClick={onModalSave} />
    </Modal>
  );
};

export default EditShopsModal;
